/**
 * @file popout
 * @author chenenhao
 */

import React, { Component } from "react";
import "./index.scss";
import TrialStudy from "@/components/basic/user/components/trialStudy";
import { changePopup } from "src/redux/basicInfo";
import { connect } from "react-redux";

@connect((state) => state, { changePopup })
class Popout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  onFormLayoutChange = () => {};

  handleClose = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    this.props.changePopup({ type: "", status: false });
  };

  render() {
    return (
      <div id="home-popout">
        <div className="home-inner">
          <div
            className="home-close"
            onClick={(e) => this.handleClose(e)}
          ></div>
          <div className="title"></div>
          <div className="main">
            <TrialStudy history={this.props.history} />
          </div>
        </div>
      </div>
    );
  }
}

export default Popout;
